import React from "react";
import {Typography} from "antd";
import "./reports.main.page.scss";
import {useTranslate} from "../../../hooks/translate.hook";
import {ComponentPropsFromRoute} from "../../../routers/routers";
import {RouteButtons} from "../../common/route-tabs/route.buttons";

export const ReportsMainPage: React.FC<ComponentPropsFromRoute> = ({routeChildren}) => {
    const t = useTranslate();

    return (
        <div className="reports-main-page">
            <Typography.Title level={3} className="reports-main-page__title">
                {t("REPORTS.TITLE")}
            </Typography.Title>
            <RouteButtons routes={routeChildren || []} />
        </div>
    );
};
